import { Component } from 'react';
import { Container } from "@mui/material";

import AddRecruiter from '../components/AddRecruiter';
import { checkStatus, goToLogin } from '../checkStatus';
import { getBaseUrl } from '../env';


const defaultState = {
  searchText: null,
  data: []
};

export default class AddRecruiterPage extends Component {

  constructor() {
    super();
    this.state = defaultState;
  }

  async componentDidMount() {
    const url = `${getBaseUrl()}/v1/employer`;
    fetch(url, {credentials:'include'})
      .then(result => checkStatus(result))
      .then(items => {
        return this.setState({ data: items.data});
      })
      .catch(error => {
        console.error(error);
        if (error.code === 401) {
          return goToLogin();
        }
        this.setState({ errorMessage: error.message || 'Unable to load employer', error });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    return <>
      <Container component="div" sx={{ margin: '1rem 0' }}>
        <h1>Add Recruiter</h1>
        <AddRecruiter />
      </Container>

    </>;
  }
}
